<template>
  <div class="box">
    <div class="numberContainer">
      <span class="percentage">{{ percent }}</span>
    </div>
    <div class="lineContainer"><div class="lineHorizontal" :data-percent="percent"></div></div>
    <div class="box__content">
      <sc-richText class="description" v-if="fields && fields.text" :field="fields.text" />
      <div class="icon"><sc-image v-if="fields && fields.icon" :media="fields.icon" /></div>
    </div>
  </div>
</template>

<script>
import { RichText, Image } from '@sitecore-jss/sitecore-jss-vue';
import { shallowRef } from 'vue';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'CIS-K12-Graphic-Item',
  components: {
    ScRichText: RichText,
    ScImage: Image
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    var percent = shallowRef(props?.fields?.percent?.value) || 0;

    return { percent };
  }
};
</script>
<style lang="scss" scoped>
.box {
  position: relative;
  margin: 0 2rem 0 0;
  padding: 0 0 3.5rem 2rem;

  @include tablet-up {
    display: flex;
    flex-direction: column;
    margin-right: 4rem;
    padding-bottom: 6rem;
  }

  .numberContainer {
    @include font-styles('Arial', 6rem, 600, normal, 7.2rem, -0.4rem, $blue);
    margin-top: -2rem;
    margin-bottom: -1.5rem;

    @include tablet-up {
      font-size: 7.2rem;
      line-height: 8.6rem;
    }
  }

  .percentage {
    &:after {
      content: '%';
      position: relative;
      top: -0.5rem;
      left: 0.2rem;
      font-size: 1.9rem;
      line-height: 2.6rem;
      letter-spacing: 0;
      vertical-align: super;

      @include tablet-up {
        font-size: 2.4rem;
      }
    }
  }

  .lineContainer {
    position: relative;
    width: calc(100% + 2rem);
    left: -2rem;
    border-top: solid 0.1rem $divider;
    margin-top: 2rem;
    margin-bottom: 1.5rem;

    @include tablet-up {
      width: 95%;
    }
  }

  .lineHorizontal {
    position: absolute;
    top: -3px;
    height: 0.4rem;
    width: 0;
    background-color: $orange;
  }

  &__content {
    display: flex;

    @include tablet-up {
      // display: block;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }

  .description {
    @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, 0, $gray);
    padding-right: 2rem;

    @include tablet-up {
      padding-right: 0;
    }

    &:deep() {
      p,
      span {
        @include font-styles('Arial', 1.6rem, 500, normal, 2.2rem, 0, $gray);
      }

      strong {
        font-weight: 600;
      }
    }
  }

  .icon {
    @include tablet-up {
      margin-top: auto;
    }

    img {
      width: auto;
      height: 4rem;

      @include tablet-up {
        height: 6rem;
        margin-top: 1rem;
      }
    }
  }
}
</style>
